var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01 4.00977H18.01V6.00977H2.01V4.00977ZM4.01 0.00976562H16.01V2.00977H4.01V0.00976562ZM18 7.99977H2C1.46957 7.99977 0.960859 8.21048 0.585786 8.58555C0.210714 8.96062 0 9.46933 0 9.99977V17.9998C0 18.5302 0.210714 19.0389 0.585786 19.414C0.960859 19.7891 1.46957 19.9998 2 19.9998H18C18.5304 19.9998 19.0391 19.7891 19.4142 19.414C19.7893 19.0389 20 18.5302 20 17.9998V9.99977C20 9.46933 19.7893 8.96062 19.4142 8.58555C19.0391 8.21048 18.5304 7.99977 18 7.99977ZM8.3 17.9998L5 14.7598L6.4 13.3598L8.3 15.2598L13.6 9.95977L15 11.3598L8.3 17.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/Vector-6.ba9caa7cf2ac95d189e6c0d4d84080b1.svg";
export { ForwardRef as ReactComponent };